<div class="bg-white p-2">
  <div>
    <p class="text-center my-3 text-primary">Make all your changes then press the submit button below</p>
    <div class="container">
      <section class="bs-box">
        <h5 class="title text text-primary">Business Details</h5>

        <div class="row align-items-center mb-3">
          <div class="col-12 col-md-6">
            Contract Status:
          </div>
          <div class="col-12 col-md-4">
            <div class="form-group col-12">
              <select class="form-select" #contract (change)='onContractSignChange(contract.value)'>
                <option [disabled]="true" [selected]="!contractStatus">
                  Not Assigned</option>
                <option *ngFor="let status of contractStatusList" [value]="status" [selected]="status == contractStatusOriginal">
                 {{status}}</option>
              </select>
            </div>
          </div>
        </div>
        <div class="row align-items-center mb-3">
          <div class="col-12 col-md-6">
            Products on Browse Page:
          </div>
          <div class="col-12 col-md-4">
            <mat-radio-group [(ngModel)]="productBrowseStatus">
              <mat-radio-button [value]="true" [checked]="productBrowseStatus" class="me-3">Yes</mat-radio-button>
              <mat-radio-button [value]="false" [checked]="!productBrowseStatus">No</mat-radio-button>
            </mat-radio-group>
          </div>
        </div>

        <div class="row align-items-center mb-3">
          <div class="col-12 col-md-6">Withdrawal Status:</div>
          <div class="col-12 col-md-4">
            <mat-radio-group [(ngModel)]="withdrwaStatus">
              <mat-radio-button [value]="true" [checked]="withdrwaStatus" class="me-3">Enabled</mat-radio-button>
              <mat-radio-button [value]="false" [checked]="!withdrwaStatus">Disabled</mat-radio-button>
            </mat-radio-group>
          </div>
        </div>

        <div class="row align-items-center mb-3">
          <div class="col-12 col-md-6">International Transactions Status:</div>
          <div class="col-12 col-md-4">
            <mat-radio-group [(ngModel)]="eligibleForInternational">
              <mat-radio-button [value]="true" [checked]="eligibleForInternational" class="me-3">Enabled</mat-radio-button>
              <mat-radio-button [value]="false" [checked]="!eligibleForInternational">Disabled</mat-radio-button>
            </mat-radio-group>
          </div>
        </div>

        <div class="row align-items-center mb-3">
          <div class="col-12 col-md-6">Phone Verification Status:</div>
          <div class="col-12 col-md-4">
            <mat-radio-group [(ngModel)]="businessVerifications.phone">
              <mat-radio-button [value]="true" [checked]="businessVerifications.phone" class="me-3">{{verificationStatus.verified}}</mat-radio-button>
              <mat-radio-button [value]="false" [checked]="!businessVerifications.phone">{{verificationStatus.unVerified}}</mat-radio-button>
            </mat-radio-group>
          </div>
        </div>

        <div class="row align-items-center mb-3">
          <div class="col-12 col-md-6">Email Verification Status:</div>
          <div class="col-12 col-md-4">
            <mat-radio-group [(ngModel)]="businessVerifications.email">
              <mat-radio-button [value]="true" [checked]="businessVerifications.email" class="me-3">{{verificationStatus.verified}}</mat-radio-button>
              <mat-radio-button [value]="false" [checked]="!businessVerifications.email">{{verificationStatus.unVerified}}</mat-radio-button>
            </mat-radio-group>
          </div>
        </div>
        <div class="row align-items-center mb-3">
          <div class="col-12 col-md-6">Facebook Verification Status:</div>
          <div class="col-12 col-md-4">
            <mat-radio-group [(ngModel)]="businessVerifications.facebook">
              <mat-radio-button [value]="true" [checked]="businessVerifications.facebook" class="me-3">{{verificationStatus.verified}}</mat-radio-button>
              <mat-radio-button [value]="false" [checked]="!businessVerifications.facebook">{{verificationStatus.unVerified}}</mat-radio-button>
            </mat-radio-group>
          </div>
        </div>


        <div class="row align-items-center mb-3">
          <div class="col-12 col-md-6">
            Business Fees:
          </div>
          <div class="col-12 col-md-4">
            <input matInput type="number" class="form-control" max="100" min="0" [(ngModel)]="marchantPercentage">
          </div>
        </div>
        <div class="row align-items-center mb-3">
          <div class="col-12 col-md-6">
            Cash Wallet Fees:
          </div>
          <div class="col-12 col-md-4">
            <input matInput class="form-control" type="number" max="100" min="0" [(ngModel)]="cashWalletPercentage">
          </div>
        </div>
        <div class="row align-items-center mb-3">
          <div class="col-12 col-md-6">
            Credit Card Limit:
          </div>
          <div class="col-12 col-md-4">
            <input matInput type="number" class="form-control" [(ngModel)]="creditCardLimit">
            <span class="hint"> (-1) means unlimited credit card payments </span>
          </div>
        </div>

        <div class="row align-items-center mb-3">
          <div class="col-12 col-md-6">
            Business Status:
          </div>
          <div class="col-12 col-md-4">
            <select class="form-control form-select" [(ngModel)]="businessStatus">
              <option *ngFor="let status of activationStatuses" [value]="status.value"
                [disabled]="['InActive', 'ZeroSales', 'Increasing', 'Decreasing', 'Inactive1month','Inactive2month','Inactive3month'].includes(status.value)">
                {{status.key}}</option>
            </select>
          </div>
        </div>
        <div class="row align-items-center mb-3">
          <div class="col-12 col-md-6">
            Business Owner Role:
          </div>
          <div class="col-12 col-md-4">
            <select class="form-control form-select" #mySelect (change)='onRoleSelectedChange(mySelect.value)'>
              <option *ngFor="let role of rolesData" [value]="role.id" [selected]="role.id == adminOrSellerRoleId">
                {{role.name}}</option>
            </select>
          </div>
        </div>
        <div class="row align-items-center mb-3">
          <div class="col-12 col-md-6 mb-3">
            Business Owner Phone Number:
          </div>
          <div class="form-group col-12 col-md-4">
            <input class="form-control" type="tel"
            (focusout) = "validateBOPhone()"
            [(ngModel)]="boPhone">
          </div>
          <div *ngIf="boPhoneError" class="col-12">
            <div style="color: rgb(255, 0, 0); text-transform: capitalize;">
              {{boPhoneError}}
            </div>
          </div>
        </div>
        <div class="row align-items-center mb-3">
          <div class="col-12 col-md-6 mb-3">
            Business Owner Email:
          </div>
          <div class="form-group col-12 col-md-4">
            <input class="form-control" type="email"
            (focusout) = "validateBOEmail()"
            [(ngModel)]="boEmail">
          </div>
          <div *ngIf="boEmailError" class="col-12">
            <div style="color: rgb(255, 0, 0); text-transform: capitalize;">
              {{boEmailError}}
            </div>
          </div>
        </div>
        <div class="row align-items-center mb-3">
          <div class="col-12 col-md-6 mb-3">
            Pending Balance to Available Balance Duration:
          </div>
          <div class="form-group col-12 col-md-4">
            <input class="form-control" type="number" min="0" [(ngModel)]="pendingToAvailable">
          </div>
          <div *ngIf="pendingToAvailableError" class="col-12">
            <div style="color: rgb(255, 0, 0); text-transform: capitalize;">
              {{ pendingToAvailableError }}
            </div>
          </div>
        </div>
        <div class="row align-items-center mb-3">
          <div class="col-12 col-md-6 mb-3">
            normal fees:
          </div>
          <div class="form-group col-12 col-md-4">
            <input class="form-control" type="number" min="0" [(ngModel)]="normalFees">
          </div>
          <div *ngIf="normalFeesError" class="col-12">
            <div style="color: rgb(255, 0, 0); text-transform: capitalize;">
              {{ normalFeesError }}
            </div>
          </div>
        </div>

        <div class="row align-items-center mb-3">
          <div class="col-12 col-md-6 mb-3">
            urgent fees:
          </div>
          <div class="form-group col-12 col-md-4">
            <input class="form-control" type="number" min="0" [(ngModel)]="urgentFees">
          </div>
          <div *ngIf="urgentFeesError" class="col-12">
            <div style="color: rgb(255, 0, 0); text-transform: capitalize;">
              {{ urgentFeesError }}
            </div>
          </div>
        </div>

        <div class="row align-items-center mb-3">
          <div class="col-12 col-md-6 mb-3">
            Marketing Fees:
          </div>
          <div class="form-group col-12 col-md-4">
            <input class="form-control" type="number" min="0" max="99.99" [(ngModel)]="marketingFees">
          </div>
          <div *ngIf="marketingFeesError" class="col-12">
            <div style="color: rgb(255, 0, 0); text-transform: capitalize;">
              {{ marketingFeesError }}
            </div>
          </div>
        </div>

        <div *ngIf="admins" class="row align-items-center mb-3">
          <div class="col-12 col-md-6 mb-3">
            Link Business to an Admin:
          </div>
          <div class="form-group col-12 col-md-4">
            <select class="form-select" #adminAssign (change)='onAdminSelectedChange(adminAssign.value)'>
              <option [disabled]="true" [selected]="!oldAssignedAdminId">
                Not Assigned</option>
              <option *ngFor="let admin of admins" [value]="admin.id" [selected]="admin.id == oldAssignedAdminId">
                {{admin.first_name}} {{admin.last_name}}</option>
            </select>
          </div>
        </div>
      </section>
      <section class="bs-box bs-options">
        <h5 class="title text text-primary">Business Options</h5>
        <div class="row align-items-center mb-3" id="advance-sales">
          <div class="col-12 col-md-4">
            Enable Advance Sales:
          </div>
          <div class="col-12 col-md-5">
            <mat-radio-group [(ngModel)]="advanceSalesStatus" (change)="changeAdvanceSalesStatus($event.value)">
              <mat-radio-button [value]="true" [checked]="advanceSalesStatus" class="me-3">Enabled</mat-radio-button>
              <mat-radio-button [value]="false" [checked]="!advanceSalesStatus">Disabled</mat-radio-button>
            </mat-radio-group>
          </div>
          <div class="row align-items-center my-3">
            <div *ngIf="advanceSalesStatus" class="col-12 col-md-4  align-items-center">
              <label>Limit: </label>
              <input matInput class="form-control" type="text" [(ngModel)]="advanceSalesLimit">
              <div *ngIf="advanceSalesError" style="color: rgb(255, 0, 0); text-transform: capitalize;">
                {{advanceSalesError}}
              </div>
            </div>

            <div class="col-12 align-items-center col-md-4" *ngIf="advanceSalesStatus">
              <label>
                Repayment Fees:
              </label>
              <input matInput class="form-control" type="number" max="100" min="0"
                [(ngModel)]="advanceRepaymentPercentage">
            </div>
            <div class="col-12 align-items-center col-md-4" *ngIf="advanceSalesStatus">
              <label>
                Monthly Fees:
              </label>
              <input matInput class="form-control" type="number" max="100" min="0" [(ngModel)]="advancedPercentage">
            </div>
          </div>
        </div>

        <div class=" row align-items-center mb-3" id="qs-pay-options">
          <div class="col-12 col-md-4">Qassatly Payment Option: </div>
          <div class="col-12 col-md-4">
            <mat-radio-group [(ngModel)]="qassatlyStatus" (change)="changeQassatly($event.value)">
              <mat-radio-button [value]="true" [checked]="qassatlyStatus" class="me-3">Enabled</mat-radio-button>
              <mat-radio-button [value]="false" [checked]="!qassatlyStatus">Disabled</mat-radio-button>
            </mat-radio-group>
          </div>
          <div *ngIf="qassatlyStatus" class="col-6 col-md-2 align-items-center">
            <label>Transaction Limit:</label>
            <input class="form-control" type="number" min="0" [(ngModel)]='qassatlyLimit'>
          </div>
          <div *ngIf="qassatlyStatus" class="col-6 col-md-2 align-items-center">
            <label>Monthly Limit:</label>
            <input class="form-control" type="number" [(ngModel)]='qassatlyMonthlyLimit'>
          </div>
          <div *ngIf="qassatlyError" class="row mb-3">
            <div class="text-danger" style="text-transform: capitalize;">
              {{qassatlyError}}
            </div>
          </div>
        </div>
        <div *ngIf="merchantID" class="row align-items-center mb-3">
          <div class="col-12 col-md-4">Merchant ID: </div>
          <div class="col-12 col-md-8">
            <input readonly class="form-control" type="text" [(ngModel)]="merchantID" id="usr">
          </div>
        </div>
        <div class="row align-items-center mb-3">
          <div class="col-12 col-md-4">
            Cash API Feature:
          </div>
          <div class="col-12 col-md-4">
            <mat-radio-group [(ngModel)]="cashApiStatus">
              <mat-radio-button [value]="true" [checked]="cashApiStatus" class="me-3">Enabled</mat-radio-button>
              <mat-radio-button [value]="false" [checked]="!cashApiStatus">Disabled</mat-radio-button>
            </mat-radio-group>
          </div>
        </div>
        <div class="row align-items-center my-2 mb-3">
          <div class="col-12 col-md-4">
            Pending to Available Balance Conversion:
          </div>
          <div class="col-12 col-md-4">
            <mat-radio-group [(ngModel)]="availableFeesStatus" (change)="changeAvailableFees($event.value)">
              <mat-radio-button [value]="true" [checked]="availableFeesStatus" class="me-3">Enabled</mat-radio-button>
              <mat-radio-button [value]="false" [checked]="!availableFeesStatus">Disabled</mat-radio-button>
            </mat-radio-group>
          </div>
          <div *ngIf="availableFeesStatus" class="col-12 col-md-4 align-items-center" id="lift-top">
            <label for="usr">Available Fees Percentage:</label>
            <input matInput class="form-control" type="number" min="0" max="99.9"  [(ngModel)]="availableFeesPercentage">
            <div *ngIf="availableFeesError" style="color: rgb(255, 0, 0); text-transform: capitalize;">
              {{ availableFeesError }}
            </div>
          </div>

        </div>
      </section>

      <section class="bs-box">
        <h5 class="title text text-primary">Cashback Options</h5>
        <div class="row align-items-center mb-3" id="cash-back">
          <div class="col-12 col-md-4">
            Cashback:
          </div>
          <div class="col-12 col-md-5">
            <mat-radio-group [(ngModel)]="cashBackStatus" (change)="changeCashbackStatus($event.value)">
              <mat-radio-button [value]="true" [checked]="cashBackStatus" class="me-3">Enabled</mat-radio-button>
              <mat-radio-button [value]="false" [checked]="!cashBackStatus">Disabled</mat-radio-button>
            </mat-radio-group>
          </div>
          <div class="row mx-0 justify-content-center" *ngIf="cashBackStatus">
            <div class="col-md-8 px-0 mb-4">
            <table class="table mb-1" [formGroup]="cashBackForm" >
              <tbody formArrayName="Cashback_Details" >
                <tr *ngFor="let tier of CashbackTiers.controls; let i = index" class="row align-items-center">
                  <td class="col-4" [formGroupName]="i" >
                    <app-number [fieldObject]="tierController['Amount']"
                    [fieldErrors]="formService.formErrors"
                    [formControlRef]="convertCashBackFormControls(i, 'Amount')"
                                ></app-number>

                  </td>
                  <td class="col-4" [formGroupName]="i" >
                    <app-number [fieldObject]="tierController['Rate']"
                    [fieldErrors]="formService.formErrors"
                    [formControlRef]="convertCashBackFormControls(i, 'Rate')"></app-number>
                  </td>
                  <td class="col-4">
                    <a class="btn" (click)="removeTiers(i)" *ngIf="CashbackTiers.controls.length > 0">
                          <i class="fa fa-trash"  style="color:red; height: 35px; transform: scale(1.5);"
                          title="Delete row"></i>
                    </a>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <button type="button"  class="btn btn-success w-50" (click)="addCashbackTiers()">
            {{ 'Sellers.Products.Add' | translate }}
          </button>
          </div>
        </div>
      </section>

      <section class="bs-box">
        <h5 class="title text text-primary">Payment Options</h5>

        <div *ngFor="let group of paymentGroupOptions;  let groupIndex = index;" class="row align-items-center my-2 mb-3">
          <div class="col-12 col-md-4">
            {{group.name}}
          </div>
          <mat-radio-group class="col-12 col-md-6 big-radio">
            <mat-radio-button *ngFor="let option of group.paymentOptions;  let optionIndex = index;" [checked]="option.enabled" [value]="option.id" (click)="handlePaymentOptionClick(groupIndex,optionIndex)">{{option.name}}</mat-radio-button>
            <mat-radio-button class="danger-radio" [checked]="group.enable==false" value="Disabled" (click)="disablePaymentGroup(groupIndex)">Disabled</mat-radio-button>
          </mat-radio-group>
          <ng-container *ngIf="group.enable==true;else elseTemplate">
            <input class="col-12 col-md-2" matInput type="number" max="100" min="0" value="{{group.fees}}" [(ngModel)]="group.fees">
          </ng-container>
          <ng-template #elseTemplate>
            <input  class="col-12 col-md-2" matInput type="text" value="Disabled" disabled>
          </ng-template>
        </div>
        <div *ngIf="paymentGroupError" class="row mb-3">
          <div class="text-danger" style="text-transform: capitalize;">
            Please add at least one group
          </div>
        </div>
      </section>
    </div>

    <div class="row align-items-center justify-content-end">
      <div class="col-12">
        <button class="btn btn-primary" (click)="submitActionInfo()"> Submit</button>
      </div>
    </div>
  </div>
</div>
